import api from 'api';

const seatsMapUrl = 'api/events/:id/sections/:section';

export default {
    fetchSeatsMap: (id, section) => api.get({path: seatsMapUrl.replace(':id', +id).replace(':section', encodeURIComponent(section))})
}